import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import HomeworkTable from './tables/homework/homeworkTable';
import useHomework from './tables/homework/useHomework';
import ButtonsCheckAll from './tables/assessment/components/ButtonsCheckAll';
import { FaArrowLeft } from 'react-icons/fa';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import CommonTableFilters from 'commonFilterComponent/commonFilterComponent';

const HomeWork = () => {
  const [filters, setFilters] = useState({}); // 👈 maintain filters in state
  const { title, description, data, tableInstance } = useHomework(filters); // 👈 call hook here ONCE
  const history = useHistory();
  const { onOpenAddModal } = tableInstance;
const { standardId, subjectId, seriesId, lessonId, sectionId } = filters;
  // this only updates filters, does not call hook
  const handleFilterChange = (updatedFilters) => {
    setFilters(updatedFilters); // 👈 triggers useEffect inside useHomework
  };

  return (
    <>
      <HtmlHead title={title} description={description} />

      <Col>
        <div className="page-title-container mb-3">
          <Row>
            <Col className="mb-2" xs={12}>
              <div className="d-flex align-items-center justify-content-between mb-3">
                       <FaArrowLeft
                         className="cursor-pointer text-primary"
                         size={24}
                         onClick={() => history.goBack()}
                       />
                       <h2 className="small-title flex-grow-1 text-center mt-2">Homeworks</h2>
                     </div>

                      <CommonTableFilters onFilterChange={handleFilterChange} />

              {/* <div className="text-muted font-heading text-small">{description}</div> */}
            </Col>
           


          </Row>
        </div>
<Row className="align-items-start">
  <Col xs={9}></Col>

  <Col
    xs={3}
    className="d-flex justify-content-end align-items-start gap-2 ms-auto"
  >
    <Button
      variant="outline-primary"
      className="btn-icon btn-icon-start"
      onClick={onOpenAddModal}
    >
      <CsLineIcons icon="plus" /> <span>Add</span>
    </Button>

    <ButtonsCheckAll tableInstance={tableInstance} />
  </Col>
</Row>
        {/* Common reusable filter component */}

        <div className="mb-5">
          {((standardId && subjectId && seriesId && lessonId && sectionId)) ? (
            <section className="scroll-section" id="stripe">
              <HomeworkTable tableInstance={tableInstance} />
            </section>
          ) : (
            <div className="text-center py-5">
              <p className="text-muted">Please select filters to filter homeworks data or Add</p>
            </div>
          )}
        </div>
      </Col>
    </>
  );
};

export default HomeWork;
